import { FC, useMemo } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { useReportsContext } from "@ryde/redux";
import {
  DATE_TIME_FORMAT_FILE_NAME,
  formatDate,
  nowTDateISO,
  PLURAL_KEY,
  TOOLTIP_DELAY_BUTTONS,
  useTimezone,
} from "@ryde/shared";

import { useReportDownload } from "./use-report-download";

export const ReportTableHeadDownload: FC = () => {
  const { reportTemplate } = useReportsContext();
  const { t } = useTranslation();
  const { timezone } = useTimezone();
  const reportTitle = useMemo(() => {
    const dateSuffix = formatDate({
      dateISO: nowTDateISO(timezone),
      dateFormat: DATE_TIME_FORMAT_FILE_NAME,
      timezone,
    });
    return reportTemplate?.translationKey
      ? `${t(reportTemplate?.translationKey)}_${dateSuffix}.csv`
      : `${t(`report.${PLURAL_KEY}`)}_${dateSuffix}.csv`;
  }, [reportTemplate?.translationKey, t, timezone]);

  const { headers, footer, tableDataRows } = useReportDownload();

  const tableDataWithFooters = useMemo(() => {
    return [...tableDataRows, footer];
  }, [footer, tableDataRows]);

  return (
    <div className="report-download-csv">
      <FramerTooltip
        content={t("general.EXPORT_CSV")}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <CSVLink
          data={tableDataWithFooters}
          headers={headers}
          filename={reportTitle}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <SVG_MUI.ReportsDownloadAdvancedSVG className="pointer" />
        </CSVLink>
      </FramerTooltip>
    </div>
  );
};
